import { builder } from '@builder.io/react'
import { useRouter } from 'next/router'
import { LoadingIndicator } from '../../components/LoadingIndicator'
import Head from 'next/head'
import React from 'react'
import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from 'next'
import '../../components/Builder/CodeComponentsRegistration'
import Layout from '../../components/Layout'
import { ServicesHowItWorksSection } from '../../components/Builder/components/ServicesHowItWorks'
import { Container } from '../../components/Container'
import { CarBrandGrid } from '../../components/Builder/components/CarBrandGrid'
import { FastAndReliableSection } from '../../components/CityPage/FastAndReliableSection'
import { FAQSection } from '../../components/CarPage/FAQSection'
import dynamic from 'next/dynamic'
import { BrakeRepairNearYouWithCities } from '../../components/LandingPage/BrakeRepairNearYouWithCities'
import { ConsultationLocationSection, LocationData } from '../../components/LocationPage/ConsultationLocationSection'
import { formatPhoneNumber } from '../../components/utils/string-utils'
import { HomeScheduleServiceFormHeader } from '../../components/LandingPage/HomeScheduleServiceHeaderForm'
import { WhyNuBrakes } from '../../components/LocationPage/WhyNuBrakes'
import { ConsultationLocations } from '../../components/LocationPage/ConsultationLocationsSection'
import { newBackendClient } from '../../components/clients/new-backend.client'
import { Query, QueryGetGblLocationBySlugArgs } from '../../generated/nest-graphql'
import { GET_GBL_LOCATION_BY_SLUG, GET_GBL_LOCATIONS } from '../../lib/locations/queries'

const CityNearYouSection = dynamic(() => import('../../components/CityPage/CityNearYouSection').then((mod) => mod.CityNearYouSection))

builder.init(process.env.BUILDER_API_KEY)

const DynamicLocationPage = (props: { location?: LocationData; isRoot?: boolean; cities?: any[] }) => {
  const router = useRouter()
  const isRoot = props?.isRoot;
  const location = props.location;

  // const { builderCities, cities, butterCities, rating, reviewCount } = props
  const { cities } = props

  // const isBuilder = !!(builderCities || Builder.isEditing || Builder.isPreviewing);
  // const notBulder = !!props.city;

  const cityName = location?.name;
  const listOfZips = [];
  const listOfMinorCities = []

  const pageTitle = !!location? ` in ${cityName}, ${location?.state}` : '';

  if (router.isFallback) {
    return <LoadingIndicator />
  }

  /* if (false) {
    return <NotFoundPage />
  }*/
  // Makes it so only the published city pages can be viewed here
  return <Layout showGetQuote={!isRoot} title={`#1 Brake Repair ${pageTitle} - NuBrakes Mobile Brake Repair`}>
    <Head>
      <meta
        name="description"
        content={`Let our technicians take care of your concerns - at your home, work, or on-site, at a Valvoline Instant Oil Change by appointment only`}
      />
    </Head>
    {/*<HomeScheduleServiceFormHeaderInline
      title={'Ditch The Repair Shop.'}
      subtitle={'Our repair experts will send you a quote in under 5 minutes.'}
      headerTitle={'We\'ll come to your home or office for brakes, oil, maintenance and more.'}
      rating={'4.95'}
      reviewCount={14270}
      ratingsText={'brake repair customers'}
      buttonText='Get a free quote'
      subheading={''} />*/}

    <HomeScheduleServiceFormHeader
      title={'DITCH THE REPAIR SHOP — OR VISIT US FOR A QUICK CONSULTATION'}
      rating={'4.95'}
      reviewCount={14270}
      subheading={''} />

    {!isRoot && (<>
      <div className="my-8 flex flex-col items-center text-center px-4">
        <h2 className="text-base sm:text-3xl mb-6 max-w-4xl">
          NuBrakes — Visit Us Inside Valvoline For a Consultation or Schedule Online
        </h2>

        {/* Responsive YouTube Embed */}
        <div className="w-full max-w-4xl aspect-video">
          <iframe
            className="w-full h-full border-0"
            src="https://www.youtube.com/embed/qot_8qfLxTQ?rel=0"
            allowFullScreen
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
    </>)}

    {isRoot && (<>
      <WhyNuBrakes />
      <ConsultationLocations />
    </>)}

    {location && (
      <ConsultationLocationSection location={location} />
    )}
    {!isRoot && (<>
      <div className='my-8 flex justify-center justify-items-center content-center items-center self-center place-items-center'>
        <ServicesHowItWorksSection
          title={`SKIP THE ${cityName} TRAFFIC, -  OR VISIT US FOR A QUICK CONSULTATION.`}
          description={`Let our technicians take care of your concerns - at your home, work, or on-site, at a Valvoline Instant Oil Change by appointment only`}
          buttonText={'Get a Quote Now'}
          steps={[
            { title: "GET YOUR FREE REPAIR QUOTE", description: "Tell us what's going on with your brakes and we’ll send a free, no-obligation quote within a few minutes", image: 'faMoneyCheckEditAlt' },
            { title: "SELECT YOUR REPAIR DATE", description: "Select a service that works for you (1) Mobile Brake Repair: Full service at your home or office (2) On-Site inspection at Valvoline Instant Oil Change (by appointment only).", image: 'faCalendarCheck' },
            { title: "ENJOY SAFER, BETTER DRIVING", description: "Our brake technicians will ensure you're safe, confident, and back on the road — without the hassle of the shop.", image: 'faCarMechanic' },
          ]}
        />
      </div>
      <Container>
        {/*<CitiesCTA phoneNumber={location.phone || ''} />*/}
        <div className="text-center w-full">
          <div className={'mt-3'}>
            Or call us at <a href={`tel:${location.phone}`}>{formatPhoneNumber(location.phone)}</a>
          </div>
        </div>

      </Container>
      <div className="border-b-[1px] border-gray-100 pt-12" />

      <CarBrandGrid
        title={`We Offer Auto Repair Services On Nearly Every Model in ${cityName}`}
        carContent={[]}
        className="pt-16"
      >
        {<div className="mt-6" />}
      </CarBrandGrid>

      <FastAndReliableSection title={`FAST AND RELIABLE BRAKE REPAIR IN ${cityName}`} />

      <FAQSection
        title={`Frequently Asked Questions - ${cityName} Repair Questions`}
        description={`Learn how NuBrakes offers convenient, expert brake service with flexible options for both on-site inspections and mobile repairs.`}
        faqs={[
          {
            question: "Can I Visit You In Person?",
            answer: "Yes! You can stop by our NuBrakes service desk located inside a Valvoline Instant Oil Change to speak with a NuBrakes trained representative about a brake inspection or service consultation. All repairs are by appointment only, either at a Valvoline Instant Oil Change location or at your home or office. "
          },
          {
            question: "Where Does the Actual Repair Happen?",
            answer: "All brake repairs are performed by our mobile technicians at your home, office, or by appointment at Valvoline Instant Oil Change. Once your inspection is complete or your quote is approved, we’ll come to you with everything needed to complete the job."
          },
          {
            question: "What Makes NuBrakes Different From a Typical Brake Shop?",
            answer: "NuBrakes offers a flexible, modern alternative to the traditional shop experience. You can either visit us inside Valvoline for a consultation, or book mobile repair service and have the work done wherever you are. We combine expert service, convenience, and transparent pricing without the hassle of the shop."
          },
          {
            question: "How Do I Get a Quote?",
            answer: "Just tell us about your vehicle and the symptoms you're noticing. We’ll send you a free, no-obligation quote in under an hour, and you can choose whether to schedule a mobile repair or stop by for a consultation first."
          },
          {
            question: "What Should I Expect During My Appointment?",
            answer: "For mobile repairs, our technician will arrive at your location, confirm the needed work, and complete the repair on-site in about 45–90 minutes. If you visit us at Valvoline for a consultation, you’ll receive a preliminary assessment and can book a mobile service appointment right from there."
          },
          {
            question: "Why Offer Both In-Person and Mobile Service?",
            answer: "Every customer is different. Some prefer to speak with someone in person before booking service — others want the ease of mobile repair right away. By offering both, we’re able to meet you where you are — whether that’s inside our Valvoline partner location or at your driveway."
          },
          {
            question: `What Areas Do You Serve Around ${cityName}?`,
            answer: `We provide mobile service throughout ${cityName} and nearby communities including Brentwood, Franklin, Hendersonville, Antioch, and others. If you're within driving distance of a Valvoline partner location, you're likely in our service zone. Or visit us on-site for an in-person consultation and preliminary assessment!`
          }
        ]}
      />
      <CityNearYouSection
        title={`The Best ${cityName} Mobile Brake Repair Near Me`}
        description={`Stop searching for a local ${cityName} brake shop near you. We cover most of the ${cityName} metro area and bring the brake shop to you.`}
        listOfZips={listOfZips}
        listOfMinorCities={listOfMinorCities}
      />
      <BrakeRepairNearYouWithCities
        title={`We’re the closest mobile brake repair service in ${cityName} near you. Skip waiting in line at the repair shop, we come to you!`}
        cities={cities}
      />
    </>)}

  </Layout>
}

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
) => {
  const slug = context.params?.slug ?? [];
  const slugArray = Array.isArray(slug) ? slug : [slug];
  const isRoot = slugArray.length === 0;

  if (isRoot) {
    return {
      props: { isRoot: true, location: null, cities: [] },
      revalidate: 3600,
    }
  }

  const slugPath = '/' + slugArray.join('/').replace(/\/+$/, '')

  console.log('slugPath', slugPath);

  try {
    const { data } = await newBackendClient.query<Query, QueryGetGblLocationBySlugArgs>({
      query: GET_GBL_LOCATION_BY_SLUG,
      variables: { slug: slugPath },
      fetchPolicy: 'no-cache',
    })

    const gblLocation = data?.getGblLocationBySlug

    console.log('gblLocation', gblLocation);

    if (!gblLocation) {
      return { notFound: true }
    }

    const location: LocationData = {
      ...gblLocation,
      zip: String(gblLocation.zip),
      hours: {
        weekday: gblLocation.hours?.weekday ?? '',
        saturday: gblLocation.hours?.saturday ?? '',
        sunday: gblLocation.hours?.sunday ?? '',
      },
      mapUrl: gblLocation.mapUrl ?? '',
      phone: gblLocation.phone ?? '',
    }

    return {
      props: { isRoot: false, location, cities: [] },
      revalidate: 3600,
    }
  } catch (error) {
    console.error(`[locations] Backend error fetching slug "${slugPath}":`, error)
    return { notFound: true }
  }
}


export const getStaticPaths: GetStaticPaths = async () => {
  try {
    const { data } = await newBackendClient.query<Query>({
      query: GET_GBL_LOCATIONS,
      fetchPolicy: 'no-cache',
    })

    const locations = data?.getGblLocations ?? []
    const paths = locations.map((loc) => {
      const cleanSlug = loc.slug.replace(/^\/+|\/+$/g, '')
      return { params: { slug: cleanSlug.split('/') } }
    })

    return { paths, fallback: true }
  } catch (error) {
    console.error('[locations] Backend error fetching paths, falling back to empty:', error)
    return { paths: [], fallback: true }
  }
}

export default DynamicLocationPage;